/**
 * Created by lovely on 2016/6/7.
 */
module.exports = {
  eventTargetCom : undefined
};


// WEBPACK FOOTER //
// ./src/views/RuntimeOption.js